import type { LoaderFunction } from 'react-router';
import store from '../../store';
import { loadDataForSelectedService } from './loaderHelper';
import { updatePage } from '../../reducers/app/appReducer';
import {
  isStoreRemoteInConsolidatedCalendar,
  isStoreService,
  isTimeInBrowserSettings,
  type ServiceLocation,
} from '../../helpers/appHelper';
import services from '../../services';
import { viewContext } from '../middleware/context';

export interface ConfirmPageLoaderData {
  IANATimeZone: string;
}

const getPostalCodeForTimeZone = (
  serviceId: string,
  location: ServiceLocation,
  storeId: string,
): string => {
  if (isStoreRemoteInConsolidatedCalendar(location, serviceId, CSS_CONFIG)) {
    return 'all';
  }
  if (isStoreService(location)) {
    const availableStores = store.getState().stores.availableStores;
    const selectedStore = availableStores.find((s) => s.value === storeId);
    return selectedStore?.zipCode || '';
  }
  return 'REMOTE';
};

const loader: LoaderFunction = async ({
  context,
}): Promise<ConfirmPageLoaderData> => {
  const view = context.get(viewContext);
  store.dispatch(updatePage('confirm'));
  const { service, storeId } = await loadDataForSelectedService(view);

  let IANATimeZone = '';
  const { location, serviceId } = service;

  if (isTimeInBrowserSettings(location, CSS_CONFIG)) {
    IANATimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else {
    const postalCode = getPostalCodeForTimeZone(serviceId, location, storeId);
    if (postalCode) {
      try {
        IANATimeZone = await services.appointment.getIANATimeZone(
          postalCode,
          serviceId,
        );
      } catch {
        // If timezone fetch fails, calendar button won't be shown
      }
    }
  }

  return { IANATimeZone };
};

export default loader;
